// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CheckboxSelect_dropdown__15hkR","option":"CheckboxSelect_option__2_92N","checkbox":"CheckboxSelect_checkbox__3FNLZ","active":"CheckboxSelect_active__2bUZL"};